import React, { useEffect, useRef, useState, useCallback } from 'react';
import KUTE from 'kute.js';
import { useParticipantIds, useActiveParticipant } from '@daily-co/daily-react';
import { pageAtom, myNftAtom, myNftBackAtom, isAuthAtom, nftIDAtom } from '../../State';
import { useRecoilState, useRecoilValue } from 'recoil';
import { ReactComponent as CloseSVG } from '../Images/buttons/closeBlackButton.svg';
import { ReactComponent as DiscordSVG } from '../Images/buttons/discord.svg';
import { ReactComponent as OpenseaSVG } from '../Images/buttons/opensealogo.svg';
import { ReactComponent as TwitterSVG } from '../Images/buttons/twitter.svg';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

import DataModel from '../Util/DataModel';

export default function NFTPartnerDetail({ setNFTPartnerDetaiID, nftPartnerDetailID }) {
  //その他
  const [nftDetailState, setNftDetailState] = useState([]);
  const [loadState, setLoadState] = useState(false);

  //詳細リンクについて
  var external_url = '';
  if (nftDetailState.externalURL != null) {
    external_url = nftDetailState.externalURL;
  } else if (nftDetailState.collection?.external_url) {
    external_url = nftDetailState.collection?.external_url;
  }

  //初回ロード時
  useEffect(() => {
    //NFT詳細を取得
    getNFTDetail();

    startAnimation();
  }, []);

  function startAnimation() {
    var anim1 = KUTE.to(
      '#nftDetailWrap',
      { scale: 1 },
      { duration: 200, easing: 'easingSinusoidalIn' },
    ).start();

    var anim1 = KUTE.to(
      '#backWrap',
      // { opacity: 0 },
      { opacity: 1 },
      { duration: 200, easing: 'easingSinusoidalIn' },
    ).start();
  }

  //NFT詳細を取得
  const getNFTDetail = async () => {
    //NFTのIDがない場合
    if (nftPartnerDetailID == null) {
      setNftDetailState('noNft');
    }
    //NFTの指定がある場合
    else {
      const nftDetail = await DataModel.getNFTDetail(nftPartnerDetailID);
      if (nftDetail != null) {
        setNftDetailState(nftDetail);
      }
    }
  };

  //背景をタップ時
  const tapBack = () => {
    setNFTPartnerDetaiID(null);
  };

  //ロード完了
  const loadImageComplete = () => {
    setLoadState(true);
  };

  const NoNFTSCreen = () => {
    return (
      <div id="nftDetailNoNftWrap">
        <div id="nftDetailNoNFTTitle">No NFT is selected by user </div>
      </div>
    );
  };

  const NFTScreen = () => {
    return (
      <div id="nftDetailGridWrap">
        <div id="nftDetailLeft">
          <div id="nftDetailLeftImage">
            {!loadState && (
              <Skeleton
                circle={true}
                baseColor={'#ccc'}
                highlightColor={'#fff'}
                width={'100%'}
                height={'100%'}
              />
            )}
            {nftDetailState.mediumImageURL != null && (
              <>
                <img
                  src={nftDetailState.mediumImageURL}
                  onLoad={loadImageComplete}
                  style={{ display: loadState ? 'block' : 'none' }}
                />
              </>
            )}
          </div>
        </div>
        <div id="nftDetailRight">
          <div id="nftPartnerExplain">* If you own one of this NFT, you can use this face.</div>
          {nftDetailState.name != null && <div id="nftDetailName">{nftDetailState.name}</div>}
          {nftDetailState.description != null && (
            <div id="nftDetailDetail">{nftDetailState.description}</div>
          )}
          <div className="nftDetailRigtGrid">
            <div className="nftDetailItem">
              <div className="nftDetailTitle">Opensea: </div>
              <div className="nftDetailBody">
                {nftDetailState.collection != null && (
                  <>
                    {nftDetailState.collection.marketplace_pages[0].marketplace_name ==
                      'OpenSea' && (
                      <a
                        target="_blank"
                        className="nftDetailButton"
                        href={nftDetailState.collection.marketplace_pages[0].collection_url}>
                        Go to opensea
                      </a>
                    )}
                  </>
                )}
              </div>
            </div>
            <div className="nftDetailItem">
              <div className="nftDetailTitle">Detail URL: </div>
              <div className="nftDetailBody">
                {external_url != '' && (
                  <a href={external_url} target="_blank">
                    {external_url}
                  </a>
                )}
              </div>
            </div>
          </div>
          <div className="nftDetailRigtGrid">
            <div className="nftDetailItem">
              <div className="nftDetailTitle">Contract Address </div>
              <div className="nftDetailBody">
                {nftDetailState.contractAddress != null && nftDetailState.contractAddress}
              </div>
            </div>
            <div className="nftDetailItem">
              <div className="nftDetailRigtGridSmall">
                <div className="nftDetailItem">
                  <div className="nftDetailTitle">NFT Type </div>
                  <div className="nftDetailBody">
                    {nftDetailState.contractType != null && nftDetailState.contractType}
                  </div>
                </div>
                <div className="nftDetailItem">
                  <div className="nftDetailTitle">Chain Name </div>
                  <div className="nftDetailBody">
                    {nftDetailState.chain != null && nftDetailState.chain}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {nftDetailState.collection != null && (
            <div id="nftDetailCollection">
              {nftDetailState.collection.marketplace_pages != null && (
                <>
                  <div id="nftDetailIcons">
                    {nftDetailState.collection.marketplace_pages[0].marketplace_name ==
                      'OpenSea' && (
                      <a
                        target="_blank"
                        href={nftDetailState.collection.marketplace_pages[0].collection_url}>
                        <OpenseaSVG />
                      </a>
                    )}
                    {nftDetailState.collection.twitter_username != null && (
                      <a
                        target="_blank"
                        href={'https://twitter.com/' + nftDetailState.collection.twitter_username}>
                        <TwitterSVG />
                      </a>
                    )}
                    {nftDetailState.collection.discord_url != null && (
                      <a target="_blank" href={nftDetailState.collection.discord_url}>
                        <DiscordSVG />
                      </a>
                    )}
                  </div>
                </>
              )}
            </div>
          )}
        </div>
      </div>
    );
  };

  let FinalView;

  if (nftDetailState == 'noNft') {
    FinalView = NoNFTSCreen;
  } else {
    FinalView = NFTScreen;
  }

  //レンダービュー
  const renderScreen = () => {
    return (
      <>
        <div id="backWrap" onClick={tapBack} style={{ opacity: '0' }}></div>
        <div id="nftDetailWrap" style={{ transform: 'scale(0,0)' }}>
          <div id="nftTitle">
            <div id="nftCloseButton">
              <CloseSVG onClick={tapBack} />
            </div>
          </div>

          <FinalView />
        </div>
      </>
    );
  };

  return renderScreen();
}
